export default __webpack_public_path__ + "static/media/475.02cc14ec.gif";